import {Injectable} from '@angular/core';
import {IDynamicUtilService} from '../main/models/IDynamicUtilService';
import {Router} from '@angular/router';
import {QueryParams} from '../main/models/queryParams';
import {UtilsService} from '@shared/utils/util';

@Injectable({
  providedIn: 'root'
})
export class DynamicUtilService implements IDynamicUtilService {

  constructor(
    private router: Router,
    private utilsService: UtilsService,
  ) {
  }

  public getCurrentModuleFromUrl(url: string) {
    return decodeURIComponent(url).split('?')[0].split('/').pop();
  }

  public getCurrentModuleFromEditUrl(url: string) {
    return decodeURIComponent(url).split('/')[url.split('/').length - 2];
  }

  /** True when the CRM module UI is hosted inside Settings (`/modules/settings/...`). */
  public isInsideSettings(url = this.router.url): boolean {
    const path = decodeURIComponent(url || '').split('?')[0];
    return /(^|\/)modules\/settings(\/|$)/.test(path);
  }

  /**
   * Absolute commands for a CRM module route.
   * When already under Settings, keep the editor/list in the Settings chrome.
   */
  public modulePath(...segments: Array<string | number>): any[] {
    const parts = segments.map((segment) => `${segment}`);
    return this.isInsideSettings() ? ['modules', 'settings', ...parts] : ['modules', ...parts];
  }

  public getReturnUrl(returnData: string): string {
    return this.utilsService.b64ToUtf8(returnData);
  }

  public updateReturnUrlWIthCurrent(queryParams: QueryParams): QueryParams {
    queryParams.returnUrl = this.utilsService.utf8ToB64(decodeURIComponent(this.router.url))
    return queryParams
  }

  public getUrlData(url: string) {
    const decodedUrl = decodeURIComponent(url);
    const urlTree = this.router.parseUrl(decodedUrl);
    const urlWithoutParams = urlTree.root.children.primary.segments.map(it => it.path).join('/');
    const queryParams = urlTree.queryParams;
    console.log(urlWithoutParams)
    console.log(queryParams)
    return {url: urlWithoutParams, queryParams}
  }

  public navigateBack(moduleConfig?: any) {
    const {queryParams} = this.getUrlData(this.router.url)

    if (queryParams.returnUrl) {
      const returnUrl = this.getReturnUrl(queryParams.returnUrl);
      const newUrlData = this.getUrlData(returnUrl)
      return this.router.navigate([newUrlData.url], {queryParams: newUrlData.queryParams});
    } else if (moduleConfig) {
      const isConfigModule = moduleConfig.id === 'config_module'
        || moduleConfig.name === 'config_module';
      if (this.isInsideSettings() && isConfigModule) {
        return this.router.navigate(['modules', 'settings'], {queryParams: {section: 'modules'}});
      }
      return this.router.navigate(this.modulePath(moduleConfig.id_number));
    }
  }
}
